import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { STORAGE_KEY } from '@/config'

const requireModule = require.context('./modules', true, /store\/index\.js$/)
const modules = {}
requireModule.keys().forEach(fileName => {
  modules[fileName.split('/')[1]] = requireModule(fileName).default
})

Vue.use(Vuex)

export default new Vuex.Store({
  modules: modules,

  plugins: [createPersistedState({
    key: STORAGE_KEY
  })]
})
